import { api } from '@/services/api/AxiosBaseService'

/**
 * Integração do atendimento com o WhatsApp (Meta Business).
 *
 * Os segredos entram mas não voltam: a API devolve apenas se estão preenchidos
 * e os últimos dígitos. Campo enviado vazio mantém o valor já gravado — para
 * apagar de fato existe `clearSecret`.
 */

export type SecretField = 'token' | 'appSecret' | 'verifyToken'

export interface SecretState {
  filled: boolean
  /** •••••••• + últimos 4 caracteres. Null quando vazio. */
  hint: string | null
  /** Está valendo o valor do .env porque o painel ainda não foi preenchido. */
  fromEnv: boolean
}

export interface WhatsAppSettings {
  phoneNumberId: string | null
  wabaId: string | null
  phoneE164: string | null
  apiVersion: string
  secrets: Record<SecretField, SecretState>
  /** URL que a equipe de integração cadastra no Meta Business. */
  webhookUrl: string
  /** Derivado das credenciais — não existe interruptor manual. */
  live: boolean
  /** O que ainda falta preencher para o canal entrar no ar. */
  missing: string[]
  statusText: string
  inbox: {
    id: string
    name: string
    status: string
    defaultTeam: { id: string; name: string } | null
  } | null
}

export interface WhatsAppPayload {
  token?: string | null
  appSecret?: string | null
  verifyToken?: string | null
  phoneNumberId?: string | null
  wabaId?: string | null
  phoneE164?: string | null
  apiVersion?: string | null
  inboxName?: string | null
  defaultTeamId?: string | null
}

const BASE = '/settings/support/whatsapp'

/** Nome do campo como o backend o conhece (para limpar um segredo). */
const SECRET_PATH: Record<SecretField, string> = {
  token: 'token',
  appSecret: 'app_secret',
  verifyToken: 'verify_token',
}

export const SupportWhatsAppService = {
  async get(): Promise<WhatsAppSettings> {
    const r = await api.get<{ data: WhatsAppSettings }>(BASE)
    return r.data.data
  },

  async update(payload: WhatsAppPayload): Promise<WhatsAppSettings> {
    const r = await api.put<{ data: WhatsAppSettings }>(BASE, payload)
    return r.data.data
  },

  async clearSecret(field: SecretField): Promise<WhatsAppSettings> {
    const r = await api.delete<{ data: WhatsAppSettings }>(`${BASE}/secret/${SECRET_PATH[field]}`)
    return r.data.data
  },
}
